import React from 'react';
import { ChevronRight, Clock } from 'lucide-react';

// Primera pantalla cuando hay más de una instalación con checklist: qué se va
// a inspeccionar. Una instalación con el checklist en validación aparece
// deshabilitada y lo dice.
export function ElegirInstalacion({ instalaciones, onElegir }) {
  return (
    <div>
      <h2 tabIndex={-1} className="text-2xl font-bold leading-tight text-foreground focus:outline-none">
        ¿Qué va a inspeccionar?
      </h2>
      <div className="mt-5 grid grid-cols-1 gap-3" role="group" aria-label="Instalación">
        {instalaciones.map((c) => {
          const deshabilitada = c.pendiente || c.items.length === 0;
          return (
            <button
              key={c.id}
              type="button"
              disabled={deshabilitada}
              onClick={() => onElegir(c.id)}
              aria-describedby={deshabilitada ? `pendiente-${c.id}` : undefined}
              className="flex min-h-[72px] w-full items-center gap-4 rounded-2xl border-2 border-border bg-white px-5 text-left shadow-card transition-colors hover:border-primary disabled:cursor-not-allowed disabled:bg-muted disabled:shadow-none disabled:hover:border-border"
            >
              <span className="flex-1">
                <span className="block text-xl font-bold text-foreground">{c.nombre}</span>
                {deshabilitada ? (
                  <span id={`pendiente-${c.id}`} className="mt-0.5 flex items-center gap-1.5 text-base font-semibold text-foreground">
                    <Clock size={16} aria-hidden="true" />
                    Checklist en validación
                  </span>
                ) : (
                  <span className="mt-0.5 block text-base text-foreground">{c.items.length} ítems</span>
                )}
              </span>
              {deshabilitada ? null : <ChevronRight size={24} aria-hidden="true" className="shrink-0 text-primary" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}

// Se pidió una instalación (/inspeccion?instalacion=...) cuyo checklist todavía
// no está activo: se dice y se ofrece otra.
export function InstalacionPendiente({ checklist, alternativas, onElegir }) {
  return (
    <div>
      <h2 tabIndex={-1} className="text-2xl font-bold leading-tight text-foreground focus:outline-none">
        {checklist.nombre}: checklist en validación
      </h2>
      <p className="mt-3 text-base text-foreground">
        Todavía no se pueden registrar inspecciones del {checklist.nombre}. El checklist se está validando con el
        inspector; cuando se active aparecerá aquí.
      </p>
      <div className="mt-5 grid grid-cols-1 gap-3">
        {alternativas.map((c) => (
          <button
            key={c.id}
            type="button"
            onClick={() => onElegir(c.id)}
            className="flex min-h-[56px] w-full items-center justify-center gap-2 rounded-2xl bg-primary px-4 text-lg font-bold text-white shadow-green"
          >
            Inspeccionar {c.nombre}
            <ChevronRight size={22} aria-hidden="true" />
          </button>
        ))}
      </div>
    </div>
  );
}
